import { ConsignmentDisbursementListPage } from "@/features/consignment-disbursement/pages/ConsignmentDisbursementListPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/vendor/consignment-disbursement/")({
	component: ConsignmentDisbursementListPage,
});
